const breadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard'
    }
];

export default breadcrumb;
